import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "rows"]

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextarea',
  props: /*@__PURE__*/_mergeModels({
    rows: { default: 4 }
  }, {
    "modelValue": {
  default: null
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const localValue = ref<string|null>(null);
const modelValue = _useModel<object|string|number|null>(__props, "modelValue");



function handleInput(event: Event): void {
  modelValue.value = (event.target as HTMLInputElement).value;
}

watch([modelValue], ([modelValue]) => {
  if (!modelValue && modelValue !== 0) {
    localValue.value = null;
    return;
  }

  localValue.value = modelValue.toString();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    onInput: handleInput,
    value: localValue.value,
    rows: _ctx.rows,
    class: "resize-none block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
  }, null, 40, _hoisted_1))
}
}

})